import Button from "../../atoms/button/Button";

//landing page learn more component
const LandingLearnMore = () => {
  return (
    <div className="space-x-8">
      <Button title="Buy Now" />
      <a href="" className="link">
        Learn More
      </a>
    </div>
  );
};

export default LandingLearnMore;
